import e from "./index13.js";
import t from "./index27.js";
import { darken as n, getContrastRatio as r, lighten as i } from "./index67.js";
import a from "./index81.js";
import o from "./index82.js";
import s from "./index83.js";
import c from "./index84.js";
import l from "./index85.js";
import u from "./index86.js";
import d from "./index87.js";
import f from "./index88.js";
//#region ../../node_modules/.pnpm/@mui+material@7.1.0_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.4__@emotion+_8c76256369110b2505f132f86162c9a6/node_modules/@mui/material/esm/styles/createPalette.js
function p() {
	return {
		text: {
			primary: "rgba(0, 0, 0, 0.87)",
			secondary: "rgba(0, 0, 0, 0.6)",
			disabled: "rgba(0, 0, 0, 0.38)"
		},
		divider: "rgba(0, 0, 0, 0.12)",
		background: {
			paper: a.white,
			default: a.white
		},
		action: {
			active: "rgba(0, 0, 0, 0.54)",
			hover: "rgba(0, 0, 0, 0.04)",
			hoverOpacity: .04,
			selected: "rgba(0, 0, 0, 0.08)",
			selectedOpacity: .08,
			disabled: "rgba(0, 0, 0, 0.26)",
			disabledBackground: "rgba(0, 0, 0, 0.12)",
			disabledOpacity: .38,
			focus: "rgba(0, 0, 0, 0.12)",
			focusOpacity: .12,
			activatedOpacity: .12
		}
	};
}
var m = p();
function h() {
	return {
		text: {
			primary: a.white,
			secondary: "rgba(255, 255, 255, 0.7)",
			disabled: "rgba(255, 255, 255, 0.5)",
			icon: "rgba(255, 255, 255, 0.5)"
		},
		divider: "rgba(255, 255, 255, 0.12)",
		background: {
			paper: "#121212",
			default: "#121212"
		},
		action: {
			active: a.white,
			hover: "rgba(255, 255, 255, 0.08)",
			hoverOpacity: .08,
			selected: "rgba(255, 255, 255, 0.16)",
			selectedOpacity: .16,
			disabled: "rgba(255, 255, 255, 0.3)",
			disabledBackground: "rgba(255, 255, 255, 0.12)",
			disabledOpacity: .38,
			focus: "rgba(255, 255, 255, 0.12)",
			focusOpacity: .12,
			activatedOpacity: .24
		}
	};
}
var g = h();
function _(e, t, r, a) {
	let o = a.light || a, s = a.dark || a * 1.5;
	e[t] || (e.hasOwnProperty(r) ? e[t] = e[r] : t === "light" ? e.light = i(e.main, o) : t === "dark" && (e.dark = n(e.main, s)));
}
function v(e = "light") {
	return e === "dark" ? {
		main: u[200],
		light: u[50],
		dark: u[400]
	} : {
		main: u[700],
		light: u[400],
		dark: u[800]
	};
}
function y(e = "light") {
	return e === "dark" ? {
		main: s[200],
		light: s[50],
		dark: s[400]
	} : {
		main: s[500],
		light: s[300],
		dark: s[700]
	};
}
function b(e = "light") {
	return e === "dark" ? {
		main: c[500],
		light: c[300],
		dark: c[700]
	} : {
		main: c[700],
		light: c[400],
		dark: c[800]
	};
}
function x(e = "light") {
	return e === "dark" ? {
		main: d[400],
		light: d[300],
		dark: d[700]
	} : {
		main: d[700],
		light: d[500],
		dark: d[900]
	};
}
function S(e = "light") {
	return e === "dark" ? {
		main: f[400],
		light: f[300],
		dark: f[700]
	} : {
		main: f[800],
		light: f[500],
		dark: f[900]
	};
}
function C(e = "light") {
	return e === "dark" ? {
		main: l[400],
		light: l[300],
		dark: l[700]
	} : {
		main: "#ed6c02",
		light: l[500],
		dark: l[900]
	};
}
function w(n) {
	let { mode: i = "light", contrastThreshold: s = 3, tonalOffset: c = .2, ...l } = n, u = n.primary || v(i), d = n.secondary || y(i), f = n.error || b(i), w = n.info || x(i), T = n.success || S(i), E = n.warning || C(i);
	function D(e) {
		let t = r(e, g.text.primary) >= s ? g.text.primary : m.text.primary;
		if (process.env.NODE_ENV !== "production") {
			let n = r(e, t);
			n < 3 && console.error([
				`MUI: The contrast ratio of ${n}:1 for ${t} on ${e}`,
				"falls below the WCAG recommended absolute minimum contrast ratio of 3:1.",
				"https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast"
			].join("\n"));
		}
		return t;
	}
	let O = ({ color: t, name: n, mainShade: r = 500, lightShade: i = 300, darkShade: a = 700 }) => {
		if (t = { ...t }, !t.main && t[r] && (t.main = t[r]), !t.hasOwnProperty("main")) throw Error(process.env.NODE_ENV === "production" ? e(11, n ? ` (${n})` : "", r) : `MUI: The color${n ? ` (${n})` : ""} provided to augmentColor(color) is invalid.\nThe color object needs to have a \`main\` property or a \`${r}\` property.`);
		if (typeof t.main != "string") throw Error(process.env.NODE_ENV === "production" ? e(12, n ? ` (${n})` : "", JSON.stringify(t.main)) : `MUI: The color${n ? ` (${n})` : ""} provided to augmentColor(color) is invalid.\n\`color.main\` should be a string, but \`${JSON.stringify(t.main)}\` was provided instead.\n
Did you intend to use one of the following approaches?

import { green } from "@mui/material/colors";

const theme1 = createTheme({ palette: {
  primary: green,
} });

const theme2 = createTheme({ palette: {
  primary: { main: green[500] },
} });`);
		return _(t, "light", i, c), _(t, "dark", a, c), t.contrastText ||= D(t.main), t;
	}, k;
	return i === "light" ? k = p() : i === "dark" && (k = h()), process.env.NODE_ENV !== "production" && (k || console.error(`MUI: The palette mode \`${i}\` is not supported.`)), t({
		common: { ...a },
		mode: i,
		primary: O({
			color: u,
			name: "primary"
		}),
		secondary: O({
			color: d,
			name: "secondary",
			mainShade: "A400",
			lightShade: "A200",
			darkShade: "A700"
		}),
		error: O({
			color: f,
			name: "error"
		}),
		warning: O({
			color: E,
			name: "warning"
		}),
		info: O({
			color: w,
			name: "info"
		}),
		success: O({
			color: T,
			name: "success"
		}),
		grey: o,
		contrastThreshold: s,
		getContrastText: D,
		augmentColor: O,
		tonalOffset: c,
		...k
	}, l);
}
//#endregion
export { w as default };

//# sourceMappingURL=index89.js.map